import WindowProvider from "./WindowProvider";

class WindowSizeProvider {
    public getWindowWidth(): number {
        return WindowProvider.getWindow().innerWidth;
    }
}

export default new WindowSizeProvider();
